import { Link } from "react-router-dom";

const VPSHostingContentTwo = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row reverse-mobile">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/resources/vps_hosting/vps_hosting_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h2>Consistent, Secure, and Always On</h2>
              <p>
                With The Pips VPS, your trading doesn’t depend on your computer
                or internet connection. Our virtual servers run your trading
                terminals and EAs continuously, ensuring no interruptions in
                order execution. Built for both manual and automated trading
                setups, our VPS solution guarantees lightning-speed
                connectivity, making it ideal for traders seeking high
                precision, reliability, and operational efficiency. It keeps
                your strategies active around the clock, even during power
                outages or network failures. Advanced security protocols protect
                your data and trading activity from external threats. Whether
                you're running complex algorithms or executing rapid-fire
                orders, The Pips VPS ensures your trading environment remains
                stable, responsive, and always ready to perform.
              </p>
              {/* <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Register now
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VPSHostingContentTwo;
